import { Fragment, h } from 'preact'; /** @jsx h */

import './BannerImage.scss';

const BannerImage = ({
    imageSrc,
    alt,
    children,
    spaceY = true,
    caption = false,
    contentPlacement = 'top',
    splitOnMobile = false
}) => {
    const isMobile = window.innerWidth < 1024;

    if (splitOnMobile && isMobile) {
        return (
            <div className="split-on-mobile">
                <div
                    className={`banner-image-container ${spaceY ? 'space-y' : ''}`}
                    style={{
                        backgroundImage: `url(${imageSrc})`
                    }}
                    alt={alt}
                ></div>
                {caption && (
                    <figure className="caption">
                        <figcaption className="caption-text">{caption}</figcaption>
                    </figure>
                )}
                <div className={`content-wrapper content-${contentPlacement}`}>
                    <div className="content-container">{children}</div>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <div
                className={`banner-image-container ${spaceY ? 'space-y' : ''}`}
                style={{
                    backgroundImage: `url(${imageSrc})`
                }}
                alt={alt}
            >
                <div className={`content-wrapper content-${contentPlacement}`}>
                    <div className="content-container">{children}</div>
                </div>
            </div>
            {caption && (
                <figure className="caption">
                    <figcaption className="caption-text">{caption}</figcaption>
                </figure>
            )}
        </Fragment>
    );
};

export default BannerImage;
